import Modal from "react-bootstrap/Modal";
import "./styles.scss";
import Circle from "../../../../../assets/images/outerCircle.svg";
import Tick from "../../../../../assets/images/tick.svg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";

export default function CheckoutSuccess(props) {
  const user = useSelector((state) => state.auth);

  const getLoginDetails = () => {
    let userName = user.username;
    let password = localStorage.getItem("PWD");
    let data = password + userName;
    let encrypted = CryptoJS.AES.encrypt(data, "doctall");
    return encrypted.toString().replaceAll("/", "DMP");
  };

  const redirectToOrders = () => {
    let consumerUrl = process.env.REACT_APP_SITE_URL;
    let url = `${consumerUrl}/orders-results`;
    window.location.href = url;
    // window.location.replace(url)
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="modal-cls-checkout-success-pop"
    >
      <div className="modal-checkout-success-cont">
        <div className="top-success-row-out">
          <div className="circle-out">
            <img src={Circle} alt="Circle" />
            <div className="tick-img">
              <img src={Tick} alt="Tick" />
            </div>
          </div>
        </div>
        <div className="success-font">Order Confirmed</div>
        <div className="description-font">
          You’ve successfully orderd for your test. We will get to you as soon
          as possible. Thanks for chossing us!
        </div>
        <div className="return-btn">
          <Link to="/">
            {" "}
            <div className="return-button">
              <span>Return to Homepage</span>
            </div>{" "}
          </Link>
          <div className="order-btn-out" onClick={redirectToOrders}>
            <div className="order-button" style={{ cursor: "pointer" }}>
              <span>View Ordersss</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
